import * as CanonicalBoard from './src/board';
import * as CanonicalCard from './src/card-front';
import * as CanonicalBoardCard from './src/board-card';
import * as CanonicalDetail from './src/detail';
import { Avatar as CanonicalAvatar } from './src/avatar/Avatar';

export {
  CanonicalBoard,
  CanonicalCard,
  CanonicalBoardCard,
  CanonicalDetail,
  CanonicalAvatar,
};
